<template>
    <div>
        <loading
            :active.sync="loading.app"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link
                    :to="{ name: back_reference }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Verifikasi OTP</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Pilih Metode Pengiriman Kode Verifikasi -->
            <div v-if="verify_step == 1">
                <div v-if="otp_type == 1">
                    <div class="section p-2">
                        <div class="text-center">
                            <h4 class="mb-0">
                                Minta Kode OTP melalui WhatsApp
                            </h4>
                            <small style="line-height: normal"
                                >Cara baru minta Kode OTP yang lebih aman</small
                            >
                        </div>
                    </div>
                    <div class="section mb-2">
                        <div class="transactions">
                            <!-- item -->
                            <a
                                href="Javascript:;"
                                class="item"
                                @click="buttonRequestOTP()"
                                style="padding: 10px"
                            >
                                <div class="detail">
                                    <img
                                        v-lazyload
                                        :src="require('@/assets/Loader-2.png')"
                                        :data-src="
                                            require('@/assets/whatsapp.png')
                                        "
                                        alt="image"
                                        class="image-block imaged"
                                        style="width: 30px"
                                    />
                                    <div style="color: #17273e">
                                        <div class="product-name">
                                            Minta Kode OTP
                                        </div>
                                        <div class="product-description mt-1">
                                            Pastikan
                                            {{ VUE_ENV.VUE_APP_NAME }} dan akun
                                            WhatsAppmu diinstal di 1 perangkat
                                        </div>
                                    </div>
                                </div>

                                <div class="right">
                                    <div class="icon">
                                        <ion-icon
                                            name="chevron-forward-outline"
                                        ></ion-icon>
                                    </div>
                                </div>
                            </a>
                            <!-- * item -->
                        </div>
                    </div>
                    <div class="section">
                        <div
                            class="text-center"
                            style="font-size: 13px; line-height: 1.2rem"
                        >
                            <p class="mb-0">
                                Coba Minta Kode OTP dengan Cara Lain
                            </p>
                            <a href="Javascript:;" @click="othersOtp()">
                                <b>Kirim OTP</b>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="section m-2 p-2" v-else>
                    <div class="text-center">
                        <h4>Pilih Metode Verifikasi</h4>
                        <small style="line-height: normal"
                            >Pilih salah satu metode dibawah ini untuk
                            mendapatkan kode Verifikasi</small
                        >
                    </div>
                    <div class="mt-3">
                        <button
                            class="btn btn-text-primary shadowed btn-block btn-lg"
                            v-for="item in sender"
                            :key="item.id"
                            @click="next_step(item.id)"
                        >
                            {{ item.name }} ke {{ phone_reference }}
                        </button>
                    </div>
                </div>
            </div>
            <div v-else-if="verify_step == 2">
                <div class="section mt-4 text-center">
                    <h1>Masukkan kode OTP</h1>
                    <h4>
                        Kode OTP telah dikirimkan ke nomor {{ phone_reference }}
                    </h4>
                </div>
                <div class="section mb-5 p-2">
                    <div class="form-group basic">
                        <input
                            type="number"
                            class="form-control verification-input"
                            placeholder="••••••"
                            maxlength="6"
                            v-model="data.verification_code"
                        />
                    </div>
                    <div class="mt-3 text-center">
                        <div style="font-size: 12px">
                            Belum dapat kode OTP? <br />
                            <a
                                v-if="countDown == 0"
                                @click="resend_code"
                                style="cursor: pointer"
                                class="text-primary"
                            >
                                <b>Kirim Ulang</b>
                            </a>
                            <b v-else class="text-default"
                                >Dapat mengirim ulang kode OTP setelah
                                {{ countDown }} detik</b
                            >
                        </div>
                    </div>
                    <div
                        class="form-button-group mx-width shadow-header-footer"
                    >
                        <ButtonLoader
                            :loading="loading.button"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            @click.native="submit()"
                            >Validasi</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </div>
        <action-sheet ref="panduan_otp" :title="'Panduan'" :inset="false">
            <div style="font-size: 13px; line-height: 1.3rem">
                <p>
                    Berikut adalah cara untuk meminta kode OTP melalui whatsapp
                    :
                </p>
                <ol>
                    <li>
                        Klik Tombol "<b class="text-primary">Minta Kode OTP</b>"
                    </li>
                    <li>
                        Kamu akan di arahkan untuk mengirimkan pesan tertentu ke
                        whatsapp milik {{ VUE_ENV.VUE_APP_NAME }}
                    </li>
                    <li>
                        Kirimkan pesan tersebut melalui nomor whatsapp kamu yang
                        terdaftar di akun {{ VUE_ENV.VUE_APP_NAME }}
                    </li>
                    <li>Kamu akan menerima Kode OTP melalui whatsapp</li>
                    <li>
                        Setelah Kode OTP diterima silahkan kembali ke aplikasi
                        {{ VUE_ENV.VUE_APP_NAME }} dan tekan tombol "<b
                            class="text-primary"
                            >Ya, Masukkan Kode OTP</b
                        >"
                    </li>
                    <li>
                        Masukkan Kode OTP pada kolom yang tersedia dan
                        selesaikan proses login
                    </li>
                </ol>
                <div class="form-group basic">
                    <button
                        class="btn btn-outline-primary btn-block btn-lg"
                        @click="modalPanduanOtp('hide')"
                    >
                        Mengerti
                    </button>
                </div>
            </div>
        </action-sheet>
        <action-sheet
            ref="konfirmasi_otp"
            :title="'Konfirmasi Permintaan'"
            :inset="false"
        >
            <div class="text-center" style="line-height: 1.3rem">
                <p>
                    Apakah kamu sudah mengikuti instruksi dan telah menerima
                    Kode OTP melalui whatsapp?
                </p>
                <div class="form-group basic">
                    <button
                        class="btn btn-primary btn-block btn-lg"
                        @click="inputOTpForm()"
                    >
                        Ya, Masukkan Kode OTP
                    </button>
                    <button
                        class="btn btn-outline-primary btn-block btn-lg"
                        @click="othersOtp()"
                    >
                        Coba cara lain
                    </button>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
    import $axios from '../../api.js';
    export default {
        name: 'auth.otp.verify',
        props: [
            'data_reference',
            'url_reference',
            'type_reference',
            'target_reference',
            'back_reference',
            'phonenumber_reference',
        ],
        data() {
            return {
                verify_step: 1,
                otp_type: 2, // 1
                countDown: 120,
                phone_reference: '',
                data: {
                    data_reference: this.data_reference,
                    verification_code: '',
                },
            };
        },
        created() {
            if (this.type_reference == undefined) {
                this.$router.push({ name: 'home' });
            }
            if (this.type_reference == 'LOGIN') {
                if (this.isAuth) {
                    this.$router.push({ name: 'auth.login' });
                } else {
                    this.phone_reference = this.auth_data.phone;
                }
            } else if (this.type_reference == 'FORGET_PIN_VERIFY') {
                this.phone_reference = this.auth_data.phone;
            } else if (this.type_reference == 'VERIFY') {
                this.phone_reference = this.customer.phone;
            } else {
                this.phone_reference = this.phonenumber_reference;
            }

            this.getSender()
                .then(() => {
                    this.$store.commit('SET_LOADING', { app: false });
                })
                .catch(() => {
                    this.$store.commit('SET_LOADING', { app: false });
                });
        },
        computed: {
            ...mapGetters(['isAuth']),
            ...mapState(['loading', 'toast', 'customer', 'VUE_ENV']),
            ...mapState('auth', {
                sender: state => state.sender,
                auth_data: state => state.auth_data,
            }),
        },
        methods: {
            ...mapActions('auth', [
                'getSender',
                'requestCode',
                'loginVerifyOtp',
                'requestAuthcode',
            ]),
            ...mapMutations('auth', ['RESET_AUTH_DATA']),
            next_step(id) {
                this.$store.commit('SET_LOADING', { app: true });
                this.$store.commit('SET_TOAST', { show: false });
                this.requestCode({ sender_id: id, phone: this.phone_reference })
                    .then(() => {
                        this.$store.commit('SET_LOADING', { app: false });
                        this.verify_step = 2;
                        this.countDown = 120;
                        this.countDownTimer();
                    })
                    .catch(error => {
                        this.$store.commit('SET_LOADING', { app: false });
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                    });
            },
            submit() {
                this.$store.commit('SET_LOADING', { button: true });
                this.$store.commit('SET_TOAST', { show: false });

                if (this.type_reference == 'LOGIN') {
                    this.loginVerifyOtp(this.data)
                        .then(response => {
                            this.$store.commit('SET_LOADING', {
                                button: false,
                            });
                            if (this.isAuth) {
                                this.$router.push({
                                    name: this.target_reference,
                                    query: { session_id: response.session_id },
                                });
                            } else {
                                this.$router.push({ name: 'auth.login' });
                            }
                        })
                        .catch(error => {
                            this.$store.commit('SET_LOADING', {
                                button: false,
                            });
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: error.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        });
                } else if (this.type_reference == 'FORGET_PIN_VERIFY') {
                    $axios
                        .post(this.url_reference, {
                            data: btoa(JSON.stringify(this.data)),
                        })
                        .then(response => {
                            // console.log(response);
                            this.$router.push({
                                name: this.target_reference,
                                params: {
                                    phone: this.phone_reference,
                                    token: response.data.data.token_signature,
                                    back_reference: 'auth.login',
                                },
                            });
                            // this.$store.commit("SET_LOADING", { app: false });
                        })
                        .catch(error => {
                            this.$store.commit('SET_LOADING', { app: false });
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: error.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        });
                } else if (this.type_reference == 'VERIFY') {
                    $axios
                        .post(this.url_reference, {
                            data: btoa(JSON.stringify(this.data)),
                        })
                        .then(response => {
                            // console.log(response);
                            this.$router.push({
                                name: this.target_reference,
                                params: {
                                    toast_reference: {
                                        show: true,
                                        message: response.data.message,
                                        tipe: 'default',
                                        icon: 'success',
                                    },
                                },
                            });
                            // this.$store.commit("SET_LOADING", { app: false });
                        })
                        .catch(error => {
                            this.$store.commit('SET_LOADING', { app: false });
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: error.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        });
                }
            },
            countDownTimer() {
                if (this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1;
                        this.countDownTimer();
                    }, 1000);
                }
            },
            resend_code() {
                this.data.verification_code = '';
                this.verify_step = 1;
            },
            buttonRequestOTP() {
                this.loading.app = true;
                this.requestAuthcode({ phone: this.phone_reference })
                    .then(response => {
                        window.open(response.data.message, '_blank');
                        this.loading.app = false;
                        this.modalKonfirmasiOtp('show');
                    })
                    .catch(error => {
                        this.$store.commit('SET_LOADING', { app: false });
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                    });
            },
            modalPanduanOtp(value) {
                let element = this.$refs.panduan_otp.$el;
                window.$(element).modal(value);
            },
            modalKonfirmasiOtp(value) {
                let element = this.$refs.konfirmasi_otp.$el;
                window.$(element).modal(value);
            },
            inputOTpForm() {
                this.modalKonfirmasiOtp('hide');
                this.verify_step = 2;
                this.countDown = 120;
                this.countDownTimer();
            },
            othersOtp() {
                this.modalKonfirmasiOtp('hide');
                this.otp_type = 2;
            },
        },
        mounted() {
            document.body.classList.add('bg-white');
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
            this.RESET_AUTH_DATA();
        },
    };
</script>
